import { AWAITING_CONFIRMATION_REASON } from "pages/StartLead/awaitingConfirmation";

import type { ReentryMode } from "./reentry";

export interface InterstitialCopy {
  title: string;
  body: string;
}

const PICK_UP_TITLE = "Let’s pick up where you left off";

/** The copy of a look-up for a submission the visitor must prove they own:
 * the quote page's re-entry for a lead awaiting confirmation, and the
 * verify page's. */
export const LOOK_UP_COPY: InterstitialCopy = {
  title: PICK_UP_TITLE,
  body: "Enter the email or mobile phone you used and we’ll get you back in.",
};

/** The headline and body for a refusal. A lead still awaiting confirmation
 * gets the look-up copy. Anyone else is on the re-entry screen: `on_file`
 * when the server knows where to send a code, `typed` when the visitor
 * says. */
export function interstitialCopy(
  reason: string,
  mode: ReentryMode,
): InterstitialCopy {
  if (reason === AWAITING_CONFIRMATION_REASON) return LOOK_UP_COPY;
  if (mode === "on_file") {
    return {
      title: PICK_UP_TITLE,
      body: "We’ll send you a code to get you back to your quote.",
    };
  }
  return {
    title: PICK_UP_TITLE,
    body: "Enter the email or mobile phone your quote was sent to and we’ll get you back in.",
  };
}

const REFUSAL_NOTES: Record<string, string> = {
  quote_link_redeemed: "This link has already been used.",
  quote_signature_redeemed: "This link has already been used.",
  quote_link_expired: "This link has expired.",
  quote_link_revoked: "This link has expired.",
  quote_signature_expired: "This link has expired.",
};

/** The small line saying why the quote did not open, for a refusal code the
 * client knows. Anything else reads as no line at all. */
export function refusalNote(reason: string): string | null {
  return REFUSAL_NOTES[reason] ?? null;
}
